// 引入布局组件
import LayoutIndex from '@/layout/LayoutIndex.vue';

// 定义路由常量
const inspectionChecksRouter = [
  {
        path: '/inspectionChecks',
    component: LayoutIndex,
    meta: { title: '其他', icon: 'inspectionChecks', requireAuth: true },
    name: 'inspectionChecks',
        redirect: '/inspectionChecks',
    children: [
      {
            path: '/inspectionChecks/inspectionsList',
        component: () => import('@/views/inventorycheck/inspectionCheck.vue'),
        name: 'inspectionCheck',
        meta: { title: '盘点管理', requireAuth: false }
      },
      {
        path: '/inspectionChecks/inspectionsList/add',
        component: () => import('@/views/inventorycheck/model/addinspectionCheck.vue'),
        name: 'addinspectionCheck',
        meta: { title: '添加盘点管理', requireAuth: false },
        hidden: true
      },
    ]
  }
];

// 导出路由
export default inspectionChecksRouter;